import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// -------------------- Auto Save Notifier --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.context.AutoSaveNotifier.';
  public static readonly autoSaveNotifier_viewingEditing = `${Id.prefix}viewingEditing`;
  public static readonly autoSaveNotifier_saveInProgress = `${Id.prefix}saveInProgress`;
  public static readonly autoSaveNotifier_saved = `${Id.prefix}saved`;
  public static readonly autoSaveNotifier_errorSaving = `${Id.prefix}errorSaving`;
}

export class LangAutoSaveNotifier {
  private constructor() {}
  public static viewingEditing(): string {
    return interpolate(Id.autoSaveNotifier_viewingEditing);
  }
  public static saveInProgress(): string {
    return interpolate(Id.autoSaveNotifier_saveInProgress);
  }
  public static saved(): string {
    return interpolate(Id.autoSaveNotifier_saved);
  }
  public static errorSaving(): string {
    return interpolate(Id.autoSaveNotifier_errorSaving);
  }
}

export class AutoSaveNotifierModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.autoSaveNotifier_viewingEditing, 'Viewing/Editing', 'Legend label for idle state');
    register.add(Id.autoSaveNotifier_saveInProgress, 'Save in progress', 'Legend label for save in progress');
    register.add(Id.autoSaveNotifier_saved, 'Saved', 'Legend label for save success');
    register.add(Id.autoSaveNotifier_errorSaving, 'Error saving', 'Legend label for save error');
  }
}
